import React, { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'

import { useHistory } from 'react-router-dom'
import { auth, Appleprovider } from "../../firebase";
import { signInWithPopup } from "firebase/auth";
import { userServices } from "../../services";
import apple from '../../assets/img/apple_login.png';
import Button from '@mui/material/Button';
import { AppleIcon } from '../../icons';


function AppleAuthForm({ closemodel, name }) {

  const { setUser, setAccessToken, startSilentRefresh, setLoaded } = useContext(AuthContext)

  const history = useHistory()

  const onSubmit = () => {

    signInWithPopup(auth, Appleprovider)
      .then((result) => {
        // var name = result?.user?.displayName?.split(' ');
        // var first_name = name[0];
        // var last_name = result?.user?.displayName?.substring(name[0]?.length);


        var sendData = {
          email: result.user.email,
          oauth_id: result.user.uid,
          user_type: 1,
          registered_on: new Date(),
        }
        setLoaded(false)
        userServices.handleOauthUser(sendData).then((result) => {
          setUser(result.data.user)
          setAccessToken(result.data.token)
          startSilentRefresh()
          history.push(`/app/dashboard`)
          closemodel()
          setLoaded(true)
        })
      })
      .catch((err) => {
        setLoaded(false)
      });
  }

  return (
    <>
      {/* <Button block layout="outline" className='oauth_btn' onClick={(e) => { e.preventDefault(); onSubmit() }}>
        <span className="icon_padding"><img className="ml-5" src={apple} alt="Apple" /> </span>
        Sign in with Apple
      </Button> */}
      <button className='auth_btn white-bg font-medium mt-3' onClick={(e) => { e.preventDefault(); onSubmit() }}>
        <AppleIcon className="w-6 h-6" aria-hidden="true" />
        <p>{name}</p>
      </button>

    </>
  )
}

export default AppleAuthForm